import React from "react";
import { Button, Card, Text, Box, Flex, Stack } from "@mantine/core";
import styled from "styled-components";

import ItemSlider from "@components/Microsite/ItemSlider";
import generateStaticMap from "@util/generateStaticMap";

export default function OrgGalleryLocationSelect({
  onLocationSelect,
  locations,
}) {
  return (
    <Stack gap="xs">
      {locations.map((loc) => (
        <StyledLocation key={loc.id} onClick={() => onLocationSelect(loc)}>
          <Box>
            <Flex gap="sm" align="center">
              <Box style={{ padding: "8px" }}>
                <img src={loc.logo_url} alt={loc.name} />
              </Box>
              <Box style={{ flexGrow: 1, paddingRight: "5px" }}>
                <Text fw={600} size="sm" mb={4}>
                  {loc.name}
                </Text>
                <Text size="xs">
                  {loc.city}, {loc.state_province}
                </Text>
              </Box>
            </Flex>
          </Box>
        </StyledLocation>
      ))}
    </Stack>
  );
  return (
    <ItemSlider
      data={locations.map((loc) => ({
        id: loc.id,
        title: loc.name,
        category: `${loc.city}, ${loc.state_province}${
          loc.distance ? ` - ${loc.distance} miles` : ""
        }`,
        image: generateStaticMap(
          {
            latitude: loc.latitude,
            longitude: loc.longitude,
          },
          {
            width: 500,
            height: 500,
          },
          14
        ),
        children: (
          <div>
            <Button
              style={{ marginTop: "1.5em" }}
              onClick={() => onLocationSelect(loc)}
            >
              Select
            </Button>
          </div>
        ),
      }))}
    />
  );
}

const StyledLocation = styled.div`
  position: relative;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 12px;
  overflow: hidden;
  background: var(--mantine-color-dark-6);
  padding: 0;
  border: 2px solid var(--mantine-color-dark-5);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border-color: var(--mantine-color-dark-4);
  }

  img {
    width: 60px;
    object-fit: contain;
    /* height: 100%; */
    height: 60px;
    border-radius: 8px 0 0 8px;
    transition: transform 0.2s ease;
    display: block;
  }

  &:hover img {
    transform: scale(1.05);
  }

  .mantine-Badge-root {
    position: absolute;
    top: 10px;
    right: 10px;
  }
`;
